import { render, staticRenderFns } from "./MensagensDash.vue?vue&type=template&id=41615ed2"
import script from "./MensagensDash.vue?vue&type=script&lang=js"
export * from "./MensagensDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports